import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, Star } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fetchPincodeInfo, fetchShops, resolveImageUrl } from "@/lib/api";

const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export default function VaranasiSpotlight() {
  const { pincode } = useApp();
  const [shop, setShop] = useState(null);
  const [imgErr, setImgErr] = useState(false);

  useEffect(() => {
    setShop(null);
    setImgErr(false);
    if (!pincode) return undefined;
    let alive = true;
    fetchPincodeInfo(pincode).then((info) => {
      if (!alive || (info?.city || "").toLowerCase() !== "varanasi") return null;
      return fetchShops({ pincode, limit: 200 }).then((list) => {
        const local = (list || []).filter((s) => (s.city || "").toLowerCase() === "varanasi")
          .sort((a, b) => String(a.id).localeCompare(String(b.id)));
        if (alive && local.length) setShop(local[Math.floor(Date.now() / WEEK_MS) % local.length]);
      });
    }).catch(() => {});
    return () => { alive = false; };
  }, [pincode]);

  if (!shop) return null;
  const target = shop.slug ? `/v/${shop.slug}` : `/shop/${shop.id}`;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-4" data-testid="varanasi-spotlight">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 bg-amber-50 border border-amber-100 rounded-2xl px-4 py-3">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          {shop.image && !imgErr ? (
            <img src={resolveImageUrl(shop.image)} alt={shop.name} onError={() => setImgErr(true)} className="w-14 h-14 rounded-xl object-cover flex-shrink-0 border border-amber-100" loading="lazy" data-testid="varanasi-spotlight-photo" />
          ) : (
            <div className="w-9 h-9 rounded-xl bg-amber-500 text-white flex items-center justify-center flex-shrink-0"><Award className="w-4 h-4" /></div>
          )}
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-wider font-semibold text-amber-700">Is hafte ki Varanasi Spotlight</div>
            <div className="font-display font-bold text-slate-900 truncate" data-testid="varanasi-spotlight-name">{shop.name}</div>
            <div className="text-xs sm:text-sm text-slate-600 flex items-center gap-2 flex-wrap">
              {shop.categories?.[0] && <span className="capitalize" data-testid="varanasi-spotlight-category">{shop.categories[0]}</span>}
              {shop.rating != null && (
                <span className="inline-flex items-center gap-0.5" data-testid="varanasi-spotlight-rating">
                  <Star className="w-3.5 h-3.5 text-amber-500 fill-amber-500" />{shop.rating}
                </span>
              )}
            </div>
          </div>
        </div>
        <Link to={target} className="self-start sm:self-center flex-shrink-0 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white text-xs sm:text-sm font-semibold px-4 py-2 transition-colors" data-testid="varanasi-spotlight-visit">
          Visit Shop
        </Link>
      </div>
    </div>
  );
}
